import { Box } from '@material-ui/core';
import styles from './Footer.module.scss';
import { Link } from 'react-router-dom';
//import Logo from 'assets/logo_sgsante.svg';

const Footer = () => (
    <Box className={styles.footer}>
        <Box display="flex" justifyContent="center" alignItems="center" className={styles.footer__content}>
            {/* <img src={Logo} alt="logo-extranet-rh" min-height="50" width="90" className="m-3" /> */}
            SG santé ©2024 -
            <Link to="/mentions_legales" className={styles.link}>
                Mentions légales
            </Link>
            -
            <a
                href="/docs/confidentialite_protection_donnees.pdf"
                onClick={(e) => {
                    e.preventDefault(); // Prevent default anchor tag behavior
                    window.open('/docs/confidentialite_protection_donnees.pdf', '_blank', 'noreferrer');
                }}
                className={styles.link}
            >
                Politique de confidentialité et de protection des données
            </a>
        </Box>
    </Box>
);

export default Footer;
